import { gql } from '@grandvisionhq/graphql';
import { contactLensLineItemFragment, prescriptionGlassLineItemFragment, solutionLineItemFragment, contactLensBundleLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, regularLineItemFragment } from '../fragments/line-item.js';

const GET_ORDER_BY_TOKEN = gql`
  query GetOrderByToken($token: String!) {
    getOrderByToken(token: $token) {
      loyaltyDetails {
        cardNumber
        points
      }
      billingAddress {
        city
        countryCode
        streetName
        streetNumber
        additionalStreetInfo
        additionalAddressInfo
        apartment
        company
        email
        firstName
        middleName
        lastName
        mobile
        phone
        pOBox
        postalCode
        region
        state
        title
        externalId
        salutation
      }
      orderDate
      orderNumber
      paymentMethod
      paymentStatus
      receiptUrl
      shippingAddress {
        city
        countryCode
        streetName
        streetNumber
        additionalStreetInfo
        additionalAddressInfo
        apartment
        company
        email
        firstName
        middleName
        lastName
        mobile
        phone
        pOBox
        postalCode
        region
        state
        title
        externalId
        salutation
      }
      shippingInfo {
        deliveryMethodName
      }
      price {
        currencyCode
        final {
          subtotal
          gross
          discount {
            amount
          }
          tax {
            amount
          }
        }
        shippingCost {
          gross
        }
        paymentCost {
          gross
        }
      }
      discountCodes {
        code
      }
      shipmentStatus
      shipmentTrackingURL
      customerDetails {
        phone
        email
        dateOfBirth
        code
        IBAN
      }
      invoiceDetails {
        certifiedEmail
        vatId
        code
        certifiedRecipientCode
        insuranceProvider
        insuranceNumber
      }
      serviceStore {
        name
        streetName
        streetNumber
      }
      payments {
        paymentMethodDetails {
          ... on VoucherDetails {
            expiresAt
            externalId
            externalReference
          }
        }
      }
      lineItems {
        ... on OrderLineItemRegular {
          ...RegularOrderLineItemFragment
        }
        ... on OrderLineItemContactLens {
          ...ContactLensOrderLineItemFragment
        }
        ... on OrderLineItemPrescriptionGlass {
          ...PrescriptionGlassOrderLineItemFragment
        }
        ... on OrderLineItemSolution {
          ...SolutionOrderLineItemFragment
        }
        ... on OrderLineItemBundle {
          ...ContactLensBundleOrderLineItemFragment
        }
        ... on OrderLineItemNonPrescriptionBundle {
          ...NonPrescriptionBundleOrderLineItemFragment
        }
      }
    }
  }
  ${contactLensLineItemFragment}
  ${prescriptionGlassLineItemFragment}
  ${solutionLineItemFragment}
  ${contactLensBundleLineItemFragment}
  ${nonPrescriptionBundleOrderLineItemFragment}
  ${regularLineItemFragment}
`;

export { GET_ORDER_BY_TOKEN };
//# sourceMappingURL=get-order-by-token.js.map
